<orbit-dialog-header [title]="data.title" />

<div class="dialog-content">
  <form [formGroup]="data.form" class="language-form">
    <div class="form-group">
      <label for="preferredLanguage">{{ 'SETTINGS.GENERAL.SELECT_LANGUAGE' | translate }} *</label>
      <select id="preferredLanguage" formControlName="preferredLanguage">
        @for (language of data.languages; track language.code) {
        <option [value]="language.code">{{ language.name }}</option>
        }
      </select>
      <div *ngIf="data.form.controls['preferredLanguage'].invalid" class="error-message">
        {{ 'SETTINGS.GENERAL.LANGUAGE_REQUIRED' | translate }}
      </div>
    </div>
  </form>
</div>

<orbit-dialog-footer>
  <div class="right-addon" right-addon>
    <orbit-button
      [flat]="true"
      [disabled]="false"
      [label]="data.cancelLabel"
      (onClick)="closeDialog(false)">
    </orbit-button>
    <orbit-button
      [disabled]="data.form.invalid"
      [label]="data.confirmLabel"
      [icon]="saveIcon"
      (onClick)="closeDialog(true)">
    </orbit-button>
  </div>
</orbit-dialog-footer>

